const NoDataText = {
    ErrText:"No data available!",
    InternalErr:'Internal server error!'
}
export default NoDataText;